import type { AppThemeConfig } from '@disenchantment/shared';
import { buildAppThemeDomDataset, buildAppThemeStyleVars } from '@disenchantment/shared';

const FONT_LINK_ID = 'disenchantment-theme-font';
const FONT_FACE_STYLE_ID = 'disenchantment-theme-font-face';

function formatForCss(format?: string): string {
  if (format === 'woff2') return 'woff2';
  if (format === 'woff') return 'woff';
  return 'truetype';
}

/** Applies theme tokens to the document (browser only). */
export function applyAppThemeCssVars(theme: AppThemeConfig): void {
  const root = document.documentElement;
  const vars = buildAppThemeStyleVars(theme);
  for (const [key, value] of Object.entries(vars)) {
    root.style.setProperty(key, value);
  }

  const dataset = buildAppThemeDomDataset(theme);
  root.dataset.theme = dataset.theme;
  root.dataset.chromeAmbient = dataset.chromeAmbient;
  root.dataset.chromeComposerGlow = dataset.chromeComposerGlow;
  root.dataset.chromeAppShell = dataset.chromeAppShell;
  root.dataset.chromeDepth = dataset.chromeDepth;

  const existing = document.getElementById(FONT_LINK_ID) as HTMLLinkElement | null;
  if (theme.typography.googleFontsUrl) {
    if (existing) {
      existing.href = theme.typography.googleFontsUrl;
    } else {
      const link = document.createElement('link');
      link.id = FONT_LINK_ID;
      link.rel = 'stylesheet';
      link.href = theme.typography.googleFontsUrl;
      document.head.appendChild(link);
    }
  } else if (existing) {
    existing.remove();
  }

  const local = theme.typography.localFont;
  const faceEl = document.getElementById(FONT_FACE_STYLE_ID) as HTMLStyleElement | null;
  if (local?.src && local.family) {
    const fmt = formatForCss(local.format);
    const css = `@font-face{font-family:${JSON.stringify(local.family)};src:url(${JSON.stringify(local.src)}) format(${JSON.stringify(fmt)});font-weight:${local.fontWeight ?? '400'};font-style:${local.fontStyle ?? 'normal'};font-display:swap;}`;
    if (faceEl) {
      faceEl.textContent = css;
    } else {
      const style = document.createElement('style');
      style.id = FONT_FACE_STYLE_ID;
      style.textContent = css;
      document.head.appendChild(style);
    }
  } else if (faceEl) {
    faceEl.remove();
  }
}
